// extracted by mini-css-extract-plugin
module.exports = {"projects__withdrawContainer":"styles_projects__withdrawContainer__2GPsC","projects__payment-column":"styles_projects__payment-column__1wnR5"};